import React from 'react';

import Button from '../../../../button';

import {
  StyledHeader,
} from './header-styles';

const Header = ({
  allowCreate = false,
  headerTitle,
  createButtonTitle,
  handleCreateTitle,
  hasItems,
}) => (
  <StyledHeader>
    <h3>{headerTitle}</h3>
    {(!hasItems || allowCreate)
      && (
      <Button
        onClick={handleCreateTitle}
      >
        {createButtonTitle}
      </Button>
      )}
  </StyledHeader>
);

export default Header;
